import { column } from '../interface/index'

export const listColumns: column[] = [
  {
    title: '序号',
    dataIndex: 'index'
  },
  {
    title: '用户组',
    dataIndex: 'name',
    scopedSlots: { customRender: 'name' }
  },
  {
    title: '用户人数',
    dataIndex: 'count'
  }
]

export const userColumns: column[] = [
  {
    title: '用户名',
    dataIndex: 'name'
  },
  {
    title: '创建时间',
    dataIndex: 'created_at'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' }
  }
]

export const poolColumns: column[] = [
  {
    title: '用户名',
    dataIndex: 'username',
    width: 150
  },
  {
    title: '姓名',
    dataIndex: 'realname',
    width: 150
  },
  {
    title: '最后登录时间',
    dataIndex: 'last_login_time'
  },
  {
    title: '过期时间',
    dataIndex: 'expire_at'
  },
  {
    title: '状态',
    dataIndex: 'status'
  }
]

export const filterColumns: column[] = [
  {
    title: '序号',
    dataIndex: 'index'
  },
  {
    title: 'API',
    dataIndex: 'api'
  },
  {
    title: 'method',
    dataIndex: 'method'
  },
  {
    title: '功能描述',
    dataIndex: 'desp'
  },
  {
    title: '标签',
    dataIndex: 'tags',
    scopedSlots: { customRender: 'tags' }
  },
  {
    title: '是否选择',
    dataIndex: 'is_select',
    scopedSlots: { customRender: 'is_select' }
  }
]

export const userTableColumns: column[] = [
  {
    title: '用户名',
    dataIndex: 'username',
    scopedSlots: { customRender: 'username' }
  },
  {
    title: '姓名',
    dataIndex: 'realname',
    scopedSlots: { customRender: 'realname' }
  },
  {
    title: '所属用户组',
    // dataIndex: 'groupString'
    dataIndex: 'groups',
    scopedSlots: { customRender: 'groups' }
  },
  {
    title: '最后登录时间',
    dataIndex: 'last_login_time'
  },
  {
    title: '过期时间',
    dataIndex: 'expire_at'
  },
  {
    title: '状态',
    dataIndex: 'status'
  }
]
